import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Radio from '@mui/material/Radio';
import Parser from 'html-react-parser';

import { getICon } from '../NotificationDrawer';
import FinancialChart from './FinancialChart';

const NotificationContent = ({ notification, isDarkMode }) => {
  if (notification.message.indexOf('[financial_chart]') !== -1) {
    const financial = JSON.parse(notification.info || notification.otherInfo)
      .financial;
    const newMessage = notification.message.split('[financial_chart]');
    return (
      <Typography component="div">
        {Parser(newMessage[0])}
        <FinancialChart financialData={financial} isDarkMode={isDarkMode} />
        {Parser(newMessage[1])}
      </Typography>
    );
  }

  return (
    <Typography component="div">{Parser(notification.message)}</Typography>
  );
};

export default function NotificationItem({
  notification,
  handleToggleRead,
  isDarkMode,
  variant = '',
}) {
  if (variant === 'toggleRead') {
    return (
      <Card variant="outlined" className="w-full">
        <Box className="notification-header">
          <Tooltip
            title={
              [1, 5].includes(notification.status)
                ? 'Đánh dấu đã đọc'
                : 'Đánh dấu chưa đọc'
            }
          >
            <div className="flex md:hidden">
              <Radio
                className="dot-badge "
                color="error"
                checked={[1, 5].includes(notification.status)}
                onClick={() =>
                  handleToggleRead(
                    ![1, 5].includes(notification.status),
                    notification.id,
                    notification.type
                  )
                }
              />
            </div>
          </Tooltip>
          {getICon(notification.type)}
          <div>{notification.timeSend}</div>
        </Box>
        <Box className="ml-3 notification-content">
          <Typography component="div">
            {Parser(notification.message)}
          </Typography>
        </Box>
      </Card>
    );
  }

  return (
    <Card variant="outlined" className="w-full">
      <Box className="notification-header">
        {getICon(notification.type)}
        <div>{notification.timeSend}</div>
      </Box>
      <Box className="ml-3 notification-content">
        <NotificationContent
          notification={notification}
          isDarkMode={isDarkMode}
        />
      </Box>
    </Card>
  );
}
